import { styled, Box } from '../../../../base';

export const StyledStatsRow = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: theme.spacing(2),
}));

export const StyledStatItem = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    flex: '1 1 auto',
}));

export const StyledIconCircle = styled(Box)<{ gradient: string }>(({ gradient }) => ({
    borderRadius: '50%',
    background: gradient,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 45,
    width: 45,
    flexShrink: 0,
}));

export const StyledVerticalDivider = styled(Box)(({ theme }) => ({
    width: 1,
    height: 35,
    backgroundColor: theme.palette.divider,
    [theme.breakpoints.down('lg')]: {
        display: 'none',
    },
}));
